import styled from 'styled-components';
import { Tooltip } from '@fluentui/react/lib/Tooltip';
import { css } from 'styled-components';

const sharedStyle = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  gap: 0.4rem;
`;

export const RequestDetailsInfoContainerStyle = styled.div`
  padding: 0 1rem;
`;

export const RequestDetailsStatusContainers = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.5rem 0;
  height: 50px;
  gap: 20px;
`;

export const RequestDetailsStatusValue = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: ${(props) => props.theme.popupParagraphColor};
  hyphens: none;
  @media (max-width: 710px) {
    font-size: 16px;
    font-weight: 400;
  }
`;

export const RequestDetailsInfoContainter = styled.div`
  display: flex;
  align-items: center;
  gap: 2.65rem;
  width: 100%;
  height: 180px;
`;

export const RequestDetailsInput = styled.div`
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: left;
  padding: 0.3rem 0;
`;

export const RequestDetailsDatesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  margin: 0.5rem 0;
  padding: 0.2rem 0;

  @media (max-width: 710px) {
    width: 100%;
  }
`;

export const RequestDetailInfoCommentsContainer = styled.div`
  margin-top: -20px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: space-between;

  @media (max-width: 710px) {
    margin-top: -7px;
    width: 100%;
    align-items: flex-start;
  }
`;

export const RequestDetailsInfoComment = styled.p`
  height: 73px;
  width: 300px;
  color: ${(props) => props.theme.popupParagraphColor};
  overflow: hidden;

  @media (max-width: 710px) {
    font-size: 16px;
  }
`;

export const RequestNumberOfWorkingDays = styled.div`
  ${sharedStyle}
  height: 50px;
  justify-content: space-evenly;
`;

export const RequestDetailsRequiredDocumentsContainer = styled.div`
  ${sharedStyle}

  @media (max-width: 710px) {
    display: none;
  }
`;

export const RequestDetailsRequiredDocumentsContainerMobile = styled.div`
  ${sharedStyle}

  @media (min-width: 710px) {
    display: none;
  }
`;

export const RequestDetailsStartEndDatesContainer = styled.div`
  width: 115px;

  @media (max-width: 710px) {
    width: 100%;
  }
`;

export const RequestDetailsEmployeeCommentContainer = styled.div`
  ${sharedStyle}
  height: 100%;

  @media (max-width: 710px) {
    display: none;
  }
`;

export const RequestDetailsEmployeeCommentContainerMobile = styled.div`
  ${sharedStyle}

  @media (min-width: 710px) {
    display: none;
  }
`;

export const RequestDetailsTooltip = styled(Tooltip)`
  background: green;
  color: white;
`;
